import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../utils/apiClient";
import "../style/DropdownMovil.css";
import { getBooleanEnv } from "../utils/env";

function Dropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropDownRef = useRef(null);

  const { authToken } = useAuth();
  const [Isadmin, SetIsadmin] = useState(false);
  const showSellButton = getBooleanEnv("REACT_APP_SHOW_SELL_BUTTON", true);
  const showAdvertisingButton = getBooleanEnv("REACT_APP_SHOW_ADVERTISING_BUTTON", true);
  const showSubastas = getBooleanEnv("REACT_APP_SHOW_SUBASTAS", true);

  useEffect(() => {
    if (authToken !== null) {
      api
        .get("usuario/getbyToken")
        .then((res) => {
          const roles = res.data.role;
          const containsSys = roles.includes("sysadmin");
          SetIsadmin(containsSys);
        });
    }
  }, [authToken]); // Add authToken as a dependency to re-run when it changes

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toogleDropdown = () => setIsOpen(!isOpen);

  return (
    <>
      <div
        ref={dropDownRef}
        style={{ position: "relative" }}
        className="whole-drop"
      >
        <button
          onClick={toogleDropdown}
          id="drop-menu-movil"
          className={isOpen ? "clicked" : ""}
          aria-label="Menú"
          aria-expanded={isOpen}
        >
          <span className="hamburger-bar" />
          <span className="hamburger-bar" />
          <span className="hamburger-bar" />
        </button>
        {isOpen && (
          <div
            style={{ position: "absolute", top: "100%", right: 0, zIndex: 1001 }}
            className="menu-drop-m"
          >
            {/* Main nav: on mobile the pill row is gone, so the app-bar menu
                is the only way to reach these. */}
            <div className="list-ref-m">
              <Link to="/" className="a-color-m">
                <center>Inicio</center>
              </Link>
            </div>
            <div className="line-m">
              <hr />
            </div>
            <div className="list-ref-m" id="second">
              <Link to="/stock" className="a-color-m">
                <center>Buscar</center>
              </Link>
            </div>
            <div className="line-m">
              <hr />
            </div>
            <div className="list-ref-m" id="second">
              <Link to="/credit" className="a-color-m">
                <center>Crédito</center>
              </Link>
            </div>
            <div className="line-m">
              <hr />
            </div>
            {showSubastas && (
              <>
                <div className="list-ref-m" id="second">
                  <Link to="/subastas" className="a-color-m">
                    <center>Subastas</center>
                  </Link>
                </div>
                <div className="line-m">
                  <hr />
                </div>
              </>
            )}
            {authToken ? (
              <>
                {showSubastas && (
                  <>
                    <div className="list-ref-m">
                      <Link to="/misofertas" className="a-color-m">
                        Mis ofertas
                      </Link>
                    </div>
                    <div className="line-m">
                      <hr />
                    </div>
                  </>
                )}
                <div className="list-ref-m">
                  <Link to="/mycars" className="a-color-m">
                    Perfil
                  </Link>
                </div>
                <div className="line-m">
                  <hr />
                </div>
                <div className="list-ref-m">
                  <Link to="/ajustes" className="a-color-m">
                    Ajustes
                  </Link>
                </div>
                <div className="line-m">
                  <hr />
                </div>
                {Isadmin && (
                  <>
                    <div className="list-ref-m" id="second">
                      <Link to="/allcarsa" className="a-color-m">
                        <center>Administrar</center>
                      </Link>
                    </div>
                    <div className="line-m">
                      <hr />
                    </div>
                    <div className="list-ref-m" id="second">
                      <Link to="/notificationsadmin" className="a-color-m">
                        <center>Notificaciones</center>
                      </Link>
                    </div>
                    <div className="line-m">
                      <hr />
                    </div>
                  </>
                )}
                {showSellButton && (
                  <>
                    <div className="list-ref-m" id="second">
                      <Link to="/sell" className="a-color-m">
                        <center>Vende tu auto</center>
                      </Link>
                    </div>
                    <div className="line-m">
                      <hr />
                    </div>
                  </>
                )}
                {showAdvertisingButton && (
                  <>
                    <div className="list-ref-m" id="second">
                      <Link to="/advertising" className="a-color-m">
                        <center>Publicidad</center>
                      </Link>
                    </div>
                    <div className="line-m">
                      <hr />
                    </div>
                  </>
                )}
                <div className="list-ref-m" id="second">
                  <Link to="/contact" className="a-color-m">
                    <center>Contáctenos</center>
                  </Link>
                </div>
              </>
            ) : (
              <>
                {showSellButton && (
                  <>
                    <div className="list-ref-m" id="second">
                      <Link to="/sell" className="a-color-m">
                        <center>Vende tu auto</center>
                      </Link>
                    </div>
                    <div className="line-m">
                      <hr />
                    </div>
                  </>
                )}
                {showAdvertisingButton && (
                  <>
                    <div className="list-ref-m" id="second">
                      <Link to="/advertising" className="a-color-m">
                        <center>Publicidad</center>
                      </Link>
                    </div>
                    <div className="line-m">
                      <hr />
                    </div>
                  </>
                )}
                <div className="list-ref-m" id="second">
                  <Link to="/login" className="a-color-m">
                    <center>Inicia sesión</center>
                  </Link>
                </div>
                <div className="line-m">
                  <hr />
                </div>
                <div className="list-ref-m" id="second">
                  <Link to="/contact" className="a-color-m">
                    <center>Contáctenos</center>
                  </Link>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default Dropdown;
